import React from 'react';
import PropTypes from 'prop-types';
import { trackLink } from '../../lib/analytics-helper';

function isMessage(clickAction, linkAction, content) {
  if (content.login.message) {
    return (<div className="login-bottom">
      <span>{content.login.message}</span>
      <span><button onClick={() => linkAction()} role="link" className="vx_btn-link login-bottom">{content.login.guestMessage}</button></span>
    </div>);
  }
  return null;
}

function onPasswordRecoveryClick(channelType) {
  trackLink({ id: 'intermediatePage', link: `smarthelp-password-recovery|${channelType}` });
  window.location.href = '/authflow/password-recovery';
}

const LogIn = ({ content, channelType, clickAction, linkAction }) => (
  <div className="text-center">
    <div className="login-header">{content.login.header}</div>
    <div className="login">{content.login.loginMessage}</div>
    <button className="login_btn btn" onClick={() => clickAction()}>{content.login.login}</button>
    <div><a href="#password-recovery" role="link" onClick={() => onPasswordRecoveryClick(channelType)}>{content.login.trouble}</a></div>
    <hr />
    {isMessage(clickAction, linkAction, content)}
    <div className="login-inst">{content.login.instruction}</div>
  </div>

);

LogIn.propTypes = {
  content: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  channelType: PropTypes.string.isRequired,
  clickAction: PropTypes.func,
  linkAction: PropTypes.func,
};

export default LogIn;
